import { render, staticRenderFns } from "./LectureEntityFormItem.vue?vue&type=template&id=9c602a62&"
import script from "./LectureEntityFormItem.vue?vue&type=script&lang=ts&"
export * from "./LectureEntityFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports